<h1>Invite to Organisation</h1>
<div [ngSwitch]="mode">
  <div *ngSwitchCase="'single'">
    <div *hasRole="adminRoles">
      <ca-invite *ngIf="!(sent | async)"
        (invite)="invite($event)"
        [disabled]="loading | async"
        [error]="error | async"
        [loading]="loading | async"
        [roleOptions]="defRoles"></ca-invite>

      <ca-sent-reset [sent]="sent | async"
        (reset)="reset($event)"></ca-sent-reset>
      <p>
        or <a [routerLink]="['./bulk']">Upload a CSV File</a>
      </p>
    </div>
    <div *hasRole="coordinatorRole">
      <ca-invite *ngIf="!(sent | async)"
        (invite)="invite($event)"
        [disabled]="loading | async"
        [error]="error | async"
        [loading]="loading | async"
        [roleOptions]="nonadminRoles"></ca-invite>

      <ca-sent-reset [sent]="sent | async"
        (reset)="reset($event)"></ca-sent-reset>
      <p>
        or <a [routerLink]="['./bulk']">Upload a CSV File</a>
      </p>
    </div>
  </div>
  <div *ngSwitchCase="'bulk'">
    <h2>Upload a CSV File</h2>
    <div>
      <ca-role-select placeholder="Default Role"
        [(ngModel)]="roleConfig.default"></ca-role-select>
      <ca-import (import)="importEvent($event)"
        [config]="preview"></ca-import>

      <h2 *ngIf="file && !(fileSuccess | async)">Data Preview</h2>
      <ca-sent-reset [sent]="(fileSuccess | async)"
        (reset)="reset($event)"></ca-sent-reset>
      <p>
        Download <a target="_blank"
          href="./assets/csv/members.csv">Team CSV template</a>
      </p>
      <p>
        or <a [routerLink]="['../']">Invite a single user</a>
      </p>
    </div>
  </div>
</div>